import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { NavigateFunction } from 'react-router-dom';

export const getHeaders = (
  navigate: NavigateFunction
): Record<string, EnhancedTableHeader> => ({
  name: {
    name: 'name',
    title: 'Name',
    type: EnhancedTableHeaderType.Clickable,
    callback: (payload) => {
      navigate(`/admin/lookups/${payload?.columns?.id}`);
    },
  },
});
